module.exports = __webpack_public_path__ + "static/media/0301pac-stickies.cf85162c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Media/0301pac-stickies.jpg
// module id = 393
// module chunks = 0